import React from 'react';

const TopMatches = () => {
  return (
    <div className="card p-4 shadow">
      <h3>My Top 3 Matches</h3>
      <p className="text-muted">View your top recommended matches based on your criteria.</p>
      <div className="alert alert-info mt-3">
        <strong>Coming Soon!</strong> This feature is under development.
      </div>
    </div>
  );
};

export default TopMatches;
